import { gql, useQuery } from '@apollo/client'
import { INotificationPreference } from '@dtos/NotificationPreference'

export const NOTIFICATION_PREFERENCES = gql`
  query NotificationPreferences {
    notificationPreferences {
      category
      enabled
      editable
      updatedAt
    }
  }
`

export interface INotificationPreferencesResult {
  notificationPreferences: INotificationPreference[]
}

export const useNotificationPreferences = () => {
  const { data, loading, error } = useQuery<INotificationPreferencesResult>(
    NOTIFICATION_PREFERENCES,
    { fetchPolicy: 'cache-and-network' },
  )

  return { preferences: data?.notificationPreferences, loading, error }
}
